<template lang="pug">
.reservation-message-modal
  b-modal(v-model="_value" size="xl" no-close-on-backdrop no-close-on-esc @ok="ok" @cancel="cancel")
    template(#modal-header="{ cancel }")
      .title(style="font-size: 20px;")
        span {{ _titleBeforeWeek }}
        span(:class="_weekCssClass") {{ _titleWeek }}
        span {{ _titleAfterWeek }}
      button.close(type="button" @click="cancel") ×

    span 件数：{{ items.length }}件
    NeedsMealsModalTable(v-model="items" :fields="_fields" :setting="setting" @onOoutingDetail="onOoutingDetail")

    template(#modal-footer="{ ok }")
      b-button.btn.modal-ok-btn(@click="ok") 閉じる
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

import NeedsMealsModalTable, { NeedsMealsModalTableField, NeedsMealsModalTableItem } from "@/pc/containers/outings/NeedsMealsModalTable.vue";
import { PcUrl } from "@/commons/constants/PcUrl";
import { OutingSettingGetModel } from "@/commons/services/OutingSettings";

/**
 * ### 食事キャンセル一覧（日付、食事指定）モーダル
 */
@Component({
  components: {
    NeedsMealsModalTable
  }
})
export default class NeedsMealsModal extends Vue {
  /** 表示可否 */
  @Prop({ required: true })
  value!: boolean;
  /** 日付 */
  @Prop()
  datetime!: number;
  /** 行情報 */
  @Prop()
  items!: Array<NeedsMealsModalTableItem>;
  /** 外出外泊届け設定 */
  @Prop()
  setting!: OutingSettingGetModel;

  get _value(): boolean {
    return this.value;
  }

  set _value(newValue: boolean) {
    this.$emit("input", newValue);
    return;
  }

  get _titleBeforeWeek(): string {
    if (!this.datetime) {
      return "";
    }
    const datetime: string = this.$dateUtil.convertNumberToString(this.datetime, "yyyy年mm月dd日");
    return `${datetime}（`;
  }

  get _titleWeek(): string {
    if (!this.datetime) {
      return "";
    }
    const dateObject: Date = this.$dateUtil.convertNumberToDate(this.datetime);
    const week: string = this.$dateUtil.getWeekName(dateObject, "ja");
    return `${week}`;
  }

  /**
   * ### 曜日の文字色CssClassの割り当て
   */
  get _weekCssClass(): string {
    let weekClassName: string = "";
    const dateObject: Date = this.$dateUtil.convertNumberToDate(this.datetime);
    const week: string = this.$dateUtil.getWeekName(dateObject, "ja");
    switch (week) {
      case "日":
        weekClassName = "sunday";
        break;
      case "土":
        weekClassName = "saturday";
        break;
      default:
        break;
    }
    return weekClassName;
  }

  get _titleAfterWeek(): string {
    return `） 届出内容`;
  }

  /**
   * ### 列を作成する
   */
  get _fields(): Array<NeedsMealsModalTableField> {
    if (!this.setting) {
      return [];
    }

    const fields: Array<NeedsMealsModalTableField> = [];
    fields.push({ key: "residentGroup", label: "利用者グループ", sortable: false, sortDirection: "desc", class: "resident-group" });
    fields.push({ key: "resident", label: "利用者名（部屋名）", sortable: false, sortDirection: "desc", class: "resident" });

    // 食事列は設定に応じて表示／非表示を切り替える
    if (this.setting.useNeedsMeal.breakfast) {
      fields.push({ key: "breakfast", label: "朝食", sortable: false, sortDirection: "desc", class: "meal-name breakfast text-center" });
    }
    if (this.setting.useNeedsMeal.lunch) {
      fields.push({ key: "lunch", label: "昼食", sortable: false, sortDirection: "desc", class: "meal-name lunch text-center" });
    }
    if (this.setting.useNeedsMeal.snack) {
      fields.push({ key: "snack", label: "おやつ", sortable: false, sortDirection: "desc", class: "meal-name snack text-center" });
    }
    if (this.setting.useNeedsMeal.dinner) {
      fields.push({ key: "dinner", label: "夕食", sortable: false, sortDirection: "desc", class: "meal-name dinner text-center" });
    }

    fields.push({ key: "control", label: "届出内容", sortable: false, sortDirection: "desc", class: "control text-center" });
    return fields;
  }

  public ok(): void {
    this.$emit("ok");
    return;
  }

  public cancel(): void {
    this.$emit("cancel");
    return;
  }

  /**
   * ### 届出内容 詳細ボタン押下イベント処理
   */
  public onOoutingDetail(item: NeedsMealsModalTableItem): void {
    this.$router.push({ name: PcUrl.OutingDetail, params: { id: `${item.id}` } });
    return;
  }
}
</script>
